var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ED1B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 9.33333V5.33333C21.3334 4.97971 21.1929 4.64057 20.9428 4.39052C20.6928 4.14048 20.3536 4 20 4H12C11.6464 4 11.3073 4.14048 11.0572 4.39052C10.8072 4.64057 10.6667 4.97971 10.6667 5.33333V9.33333M16 14.6667V22.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 9.33325H26.6666M22.76 26.7599L24 9.33325H7.99998L9.23998 26.7599C9.26364 27.0971 9.4145 27.4127 9.66203 27.643C9.90956 27.8732 10.2353 28.0007 10.5733 27.9999H21.4266C21.7647 28.0007 22.0904 27.8732 22.3379 27.643C22.5855 27.4127 22.7363 27.0971 22.76 26.7599Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteAlt);
export default __webpack_public_path__ + "static/media/icon_delete_alt.a91e1243760a20d9cbfd69c232e4f94c.svg";
export { ForwardRef as ReactComponent };